import { createApiProxy } from "../utils/client-utils";
import apiRoutesInfo from "./api";

export const routes = {
  api: apiRoutesInfo,
};

export const apiClient = createApiProxy(routes);
